import { Write_bytes } from './actions/Write_bytes';
import { Write_bytes32 } from './actions/Write_bytes32';
import { Write_fct_bytes } from './actions/Write_fct_bytes';
import { Write_fct_bytes32 } from './actions/Write_fct_bytes32';
import { Write_fct_uint256 } from './actions/Write_fct_uint256';
import { Write_uint256 } from './actions/Write_uint256';
import { Read_bytes } from './getters/Read_bytes';
import { Read_bytes32 } from './getters/Read_bytes32';
import { Read_fct_bytes } from './getters/Read_fct_bytes';
import { Read_fct_bytes32 } from './getters/Read_fct_bytes32';
import { Read_fct_uint256 } from './getters/Read_fct_uint256';
import { Read_uint256 } from './getters/Read_uint256';
import { SupportsInterface } from './getters/SupportsInterface';
var actions = {
    Write_bytes: Write_bytes,
    Write_bytes32: Write_bytes32,
    Write_fct_bytes: Write_fct_bytes,
    Write_fct_bytes32: Write_fct_bytes32,
    Write_fct_uint256: Write_fct_uint256,
    Write_uint256: Write_uint256,
};
var getters = {
    Read_bytes: Read_bytes,
    Read_bytes32: Read_bytes32,
    Read_fct_bytes: Read_fct_bytes,
    Read_fct_bytes32: Read_fct_bytes32,
    Read_fct_uint256: Read_fct_uint256,
    Read_uint256: Read_uint256,
    SupportsInterface: SupportsInterface,
};
var SecureStorage = {
    actions: actions,
    getters: getters,
};
export { SecureStorage };
